import { infiniteQueryOptions, keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

import type { ListStonesParams } from '@nucleus-commerce/api-client/platform';

import { diamondsApi } from '../api/diamonds-api';

import { diamondKeys } from './diamond-keys';

const PAGE_SIZE = 25;

export function stonesQueryOptions(params: ListStonesParams) {
  return infiniteQueryOptions({
    queryKey: diamondKeys.stoneList(params),
    queryFn: ({ pageParam }) =>
      diamondsApi.stones({
        ...params,
        limit: PAGE_SIZE,
        ...(pageParam ? { cursor: pageParam } : {}),
      }),
    initialPageParam: null as string | null,
    getNextPageParam: (page) => page.nextCursor,
  });
}

/** Newest first; filters come from the URL, "Load more" follows nextCursor. */
export function useStones(params: ListStonesParams) {
  return useInfiniteQuery({ ...stonesQueryOptions(params), placeholderData: keepPreviousData });
}
